import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ReportParams {
  id?: number[];
  subTotal?: boolean;
  details?: boolean;
  sum?: string;
  custMode?: { external: boolean; internal: boolean };
  per?: string;
  type?: string;
  from: string;
  to: string;
}

export interface ReportData {
  name?: string;
  customername?: string;
  project_name?: string;
  activity_name?: string;
  sum: number;
  pris?: number;
  timpris?: number;
  reporteddate?: string;
  sumNum?: number;
  prisNum?: number;
  timprisNum?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private apiUrl = 'api/report';

  constructor(@Inject(HttpClient) private http: HttpClient) {}

  get(params: ReportParams): Observable<ReportData[]> {
    let httpParams = new HttpParams().set('from', params.from).set('to', params.to);

    // Add each ID as a separate parameter (backend expects multiple 'id' params)
    if (params.id && params.id.length > 0) {
      params.id.forEach((id) => {
        httpParams = httpParams.append('id', String(id));
      });
    }

    if (params.subTotal !== undefined) {
      httpParams = httpParams.set('subTotal', String(params.subTotal));
    }

    if (params.details !== undefined) {
      httpParams = httpParams.set('details', String(params.details));
    }

    if (params.sum) {
      httpParams = httpParams.set('sum', params.sum);
    }

    if (params.custMode) {
      httpParams = httpParams.set('custMode', JSON.stringify(params.custMode));
    }

    if (params.per) {
      httpParams = httpParams.set('per', params.per);
    }

    if (params.type) {
      httpParams = httpParams.set('type', params.type);
    }

    return this.http.get<ReportData[]>(`${this.apiUrl}/${params.from}/${params.to}`, {
      params: httpParams,
    });
  }
}
